import React from "react";
import { FaEye, FaRegEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";

export default function EmailTemplateList() {
  return (
    <div>
      <div className="display-card table-responsive invoiceListing">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Created Date</th>
              <th>Updated Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Welcome Email Template</td>
              <td>This is email to sent users when they onboard the system.</td>
              <td>Jul 23, 2025 2:08 PM</td>
              <td>Jul 23, 2025 2:08 PM</td>
              <td>
                <div className="d-flex justify-content-around align-items-center">
                  {/* <FaEye size={15} /> */}
                  <FaRegEdit className="mx-2" size={15} />
                  <MdDelete
                    size={15}
                    //   onClick={() => {
                    //     handledeleteShow();
                    //     setDeleteid(customer?._id);
                    //   }}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
